import fetchAPI from '../utils/service';

function getCategoriesRequest() {
  return {
    type: 'GET_CATEGORIES_REQUEST',
  };
}
function getCategoriesSuccess(payload) {
  return {
    type: 'GET_CATEGORIES_SUCCESS',
    payload,
  };
}
function getCategoriesFailure() {
  return {
    type: 'GET_CATEGORIES_FAILURE',
  };
}

function getCategories() {
  return async (dispatch) => {
    await dispatch(getCategoriesRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/category',
      });
      if (res.status === 200) {
        await dispatch(getCategoriesSuccess(res.data));
      } else {
        await dispatch(getCategoriesFailure());
      }
    } catch (error) {
      await dispatch(getCategoriesFailure());
    }
  };
}

function getCategoryRequest(payload) {
  return {
    type: 'GET_CATEGORY_REQUEST',
    payload,
  };
}
function getCategorySuccess(payload) {
  return {
    type: 'GET_CATEGORY_SUCCESS',
    payload,
  };
}
function getCategoryFailure(payload) {
  return {
    type: 'GET_CATEGORY_FAILURE',
    payload,
  };
}

function getCategory(id) {
  return async (dispatch) => {
    await dispatch(getCategoryRequest({ id }));
    try {
      const res = await fetchAPI({
        endpoints: `/category/${id}`,
      });
      if (res.status === 200) {
        await dispatch(getCategorySuccess(res.data));
      } else {
        await dispatch(getCategoryFailure());
      }
    } catch (error) {
      await dispatch(getCategoryFailure({ id }));
    }
  };
}

function createCategoryRequest() {
  return {
    type: 'CREATE_CATEGORY_REQUEST',
  };
}
function createCategorySuccess(data) {
  return {
    type: 'CREATE_CATEGORY_SUCCESS',
    payload: {
      data,
    },
  };
}
function createCategoryFailure() {
  return {
    type: 'CREATE_CATEGORY_FAILURE',
  };
}

function createCategory({ data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(createCategoryRequest());
    try {
      const res = await fetchAPI({
        method: 'POST',
        data,
        endpoints: '/category',
      });
      if (res.status === 201) {
        await dispatch(createCategorySuccess(res.data));
        await response.success();
      } else {
        await dispatch(createCategoryFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(createCategoryFailure());
      await response.failure();
    }
  };
}

function editCategoryRequest() {
  return {
    type: 'EDIT_CATEGORY_REQUEST',
  };
}
function editCategorySuccess(data, _id) {
  return {
    type: 'EDIT_CATEGORY_SUCCESS',
    payload: {
      data,
      _id,
    },
  };
}
function editCategoryFailure() {
  return {
    type: 'EDIT_CATEGORY_FAILURE',
  };
}

function editCategory({ _id, data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(editCategoryRequest());
    try {
      const res = await fetchAPI({
        method: 'PATCH',
        data,
        endpoints: `/category/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(editCategorySuccess(res.data, _id));
        await response.success();
      } else {
        await dispatch(editCategoryFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(editCategoryFailure());
      await response.failure();
    }
  };
}

function deleteCategoryRequest() {
  return {
    type: 'DELETE_CATEGORY_REQUEST',
  };
}
function deleteCategorySuccess(_id) {
  return {
    type: 'DELETE_CATEGORY_SUCCESS',
    payload: {
      _id,
    },
  };
}
function deleteCategoryFailure() {
  return {
    type: 'DELETE_CATEGORY_FAILURE',
  };
}

function deleteCategory({ _id, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(deleteCategoryRequest());
    try {
      const res = await fetchAPI({
        method: 'DELETE',
        endpoints: `/category/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(deleteCategorySuccess(_id));
        await response.success();
      } else {
        await dispatch(deleteCategoryFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(deleteCategoryFailure());
      await response.failure();
    }
  };
}

function changeWidgetPositionRequest() {
  return {
    type: 'CHANGE_WIDGET_POSITION_REQUEST',
  };
}
function changeWidgetPositionSuccess(data, _id, newPosition) {
  return {
    type: 'CHANGE_WIDGET_POSITION_SUCCESS',
    payload: {
      data,
      _id,
      newPosition,
    },
  };
}
function changeWidgetPositionFailure() {
  return {
    type: 'CHANGE_WIDGET_POSITION_FAILURE',
  };
}

function changeWidgetPosition({ _id, data: { newPosition }, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(changeWidgetPositionRequest());
    try {
      const res = await fetchAPI({
        method: 'PATCH',
        data: { widgetPosition: newPosition },
        endpoints: `/category/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(changeWidgetPositionSuccess(res.data, _id, newPosition));
        await response.success();
      } else {
        await dispatch(changeWidgetPositionFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(changeWidgetPositionFailure());
      await response.failure();
    }
  };
}

function changeAnnouncementRequest() {
  return {
    type: 'CHANGE_ANNOUNCEMENT_REQUEST',
  };
}
function changeAnnouncementSuccess(data, _id) {
  return {
    type: 'CHANGE_ANNOUNCEMENT_SUCCESS',
    payload: {
      data,
      _id,
    },
  };
}
function changeAnnouncementFailure() {
  return {
    type: 'CHANGE_ANNOUNCEMENT_FAILURE',
  };
}

function changeAnnouncement({ _id, data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(changeAnnouncementRequest());
    try {
      const res = await fetchAPI({
        method: 'PATCH',
        data,
        endpoints: `/category/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(changeAnnouncementSuccess(res.data, _id));
        await response.success();
      } else {
        await dispatch(changeAnnouncementFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(changeAnnouncementFailure());
      await response.failure();
    }
  };
}

function logoutCategory() {
  return {
    type: 'LOGOUT',
  };
}

export {
  getCategories,
  getCategory,
  createCategory,
  editCategory,
  deleteCategory,
  logoutCategory,
  changeWidgetPosition,
  changeAnnouncement,
};



// WEBPACK FOOTER //
// ./src/actions/category.js